/*
 * @Author: wangxiang 
 * @Date: 2019-11-27 19:29:49 
 * @Last Modified by: wangxiang
 * @Last Modified time: 2019-12-06 17:35:15
 */
import { pluginList } from './load-plugins';
import Element from './engine/element';
import NodeWrapper from './engine/node-wrapper';

const Engine = {
  name: 'engine',
  props: {
    work: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentPage: {
      type: Number,
      default: 0
    }
  },
  components: {
    NodeWrapper
  },
  methods: {
    renderPreview(h, _elements, index, currentPage) {
      const elements = _elements.map(element => new Element(element));

      return (
        <div style={{ height: '100%', position: 'relative' }}>
          {
            elements.filter(element => !element.isContainer).map((element) => {
              return <node-wrapper element={element}>
                {h(element.name, element.getPreviewData({ position: 'static', isRem: false }))}
              </node-wrapper>;
            })
          }
          {
            index === currentPage && <div style={{ position: 'absolute', width: '375px', height: '563px', zIndex: 1, top: 0, left: 0, right: 0, bottom: 0, margin: 'auto' }}>
              {
                elements.filter(element => element.isContainer).map((element) => {
                  return <node-wrapper element={element} index={index} currentPage={currentPage}>
                    {h(element.name, element.getPreviewData({ position: 'static', isRem: false }))}
                  </node-wrapper>;
                })
              }
            </div>
          }
        </div>
      )
    }
  },
  render(h) {
    const { work, currentPage } = this;

    if (!work.pages) {
      return false;
    }
    return (
      <div id="work-container" data-work-id={work.id}>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            {
              work.pages.map((page, index) => {
                return (
                  <section key={index} class="swiper-slide flat">
                    {this.renderPreview(h, page.elements, index, currentPage)}
                  </section>
                )
              })
            }
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    )
  }
};

const install = function (Vue) {
  Vue.component(Engine.name, Engine)
  pluginList.forEach(plugin => {
    Vue.component(plugin.name, plugin.component)
  })
};

export default {
  install
}



// WEBPACK FOOTER //
// ./src/module/album/engine.js